import { Button, Spinner } from "react-bootstrap";
import Box from "@mui/material/Box";
import React from "react";
import "./FormNavigation.css";
export default function FormNavigation({
  steps,
  activeStep,
  handleNext,
  handleBack,
  showError,
  errorMessage,
  isPendingRequest,
}) {
  const buttonText = activeStep === steps.length - 1 ? "SUBMIT ORDER" : "Next";
  const buttonClass =
    buttonText === "SUBMIT ORDER" ? "next-button request-quote" : "next-button";

  return (
    <div>
      {showError && <p id = "error-message" className="error-message">{errorMessage}</p>}
      <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
        {activeStep !== 0 && (
          <Button
            className="back-button"
            id="back-button"
            onClick={handleBack}
            sx={{ mr: 3 }}
            disabled={isPendingRequest}
          >
            Back
          </Button>
        )}
        <Box sx={{ flex: "2 2 auto" }} />
        <Button
          onClick={handleNext}
          className={buttonClass}
          id="next-button"
          disabled={showError || isPendingRequest}
        >
          {isPendingRequest ? (
            <Spinner animation="border" size="sm" />
          ) : (
            buttonText
          )}
        </Button>
      </Box>
    </div>
  );
}
